export const ELECTRON_THEME_CHANGE = 'ELECTRON_THEME_CHANGE';
